module.exports = "/images/Theme Park.svg?fa1d038291d5726c46f75fdb98bf0303";